<template>
  <Modal v-model="visible" width="410px" title="新增质检保单" :footer-hide="true" :mask-closable="false" class="my-modal top">
    <Form ref="form" :model="formData" :label-width="90" class="page-form" v-if="visible" >
      <FormItem prop="policyNo" label="保单号" :rules="$units.formRule.required('请输入')" class="full">
        <Input v-model="formData.policyNo" placeholder="请输入"/>
      </FormItem>
    </Form>
    <div class="ivu-modal-footer">
      <Button type="text" @click="visible=false">取消</Button>
      <Button type="primary" @click="submit">提交</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  components: {
  },
  props: [],
  data() {
    return {
      visible: false,
      loading:false,
      formData:{},
    };
  },
  created() {
  },
  methods: {
    open() {
      this.formData = {
      };
      this.visible = true;
    },
    submit(){
      this.$refs.form.validate().then(isok=>{
        if(!isok){
          return;
        }
        const formData = JSON.parse(JSON.stringify(this.formData));
        if(this.loading){
          return;
        }
        this.loading = true;
        this.$http({
          type: "POST",
          url: "/buz/policy/addConfirmRightPolicy",
          data: formData
        }).then(res => {
          this.$notice.success("提交成功");
          this.visible = false;
          this.$nextTick(()=>{
            this.$emit("success")
          })
        }).finally(res => {
          this.loading = false;
        });

      })
    },
  },

};
</script>
<style lang="scss" scoped>

</style>
